import React, { useCallback } from 'react';

import { Formik } from 'formik';
import type { FormikProps } from 'formik';
import type { IPartnerCommissionFilter } from 'v2/interfaces/reports/partnerCommissions';
import { initialFilter, partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

import { Form } from './Form';
import { validationSchema } from './validation';

export const Filter = () => {
  const onSubmit = useCallback(
    (values: IPartnerCommissionFilter, { setSubmitting }: FormikProps<IPartnerCommissionFilter>) => {
      partnerCommissionsService.setFilter(values);
      setSubmitting(false);
    },
    []
  );

  return (
    <Formik initialValues={initialFilter} validationSchema={validationSchema} onSubmit={onSubmit}>
      <Form />
    </Formik>
  );
};
